module.exports = function getResource(label, vars = []) {
    let resources = {
        loves: 'Les favoris',
        viewAllLovesAddList1: 'Visionnez tous vos articles favoris ici en',
        viewAllLovesAddList2: 'les ajoutant à votre liste de Favoris.'
    };
    return resources[label];
};
